const LOCATION_API_BASE = "/api/location";

async function fetchLocationList<T = any>(url: string, context: string): Promise<T[]> {
    try {
        const response = await fetch(url, {
            headers: {
                Accept: "application/json",
            },
        });

        if (!response.ok) {
            console.error(`Errore ${context}: ${response.status} ${response.statusText}`);
            return [];
        }

        const rawBody = await response.text();
        if (!rawBody.trim()) {
            console.error(`Errore ${context}: risposta vuota`);
            return [];
        }

        try {
            const data = JSON.parse(rawBody);
            return Array.isArray(data) ? data : [];
        } catch {
            console.error(`Errore ${context}: risposta non JSON`);
            return [];
        }
    } catch (error) {
        console.error(`Errore ${context}:`, error);
        return [];
    }
}

export async function fetchCities(search: string) {
    const normalizedSearch = search.trim();
    if (normalizedSearch.length < 3) {
        return [];
    }

    const params = new URLSearchParams({ search: normalizedSearch });
    return fetchLocationList(`${LOCATION_API_BASE}/cities?${params.toString()}`, "ricerca comuni");
}

export async function fetchNations() {
    return fetchLocationList(`${LOCATION_API_BASE}/nations`, "recupero nazioni");
}

export async function fetchRegions(nationId: string) {
    const normalizedNationId = nationId.trim();
    if (!normalizedNationId) {
        return [];
    }

    return fetchLocationList(
        `${LOCATION_API_BASE}/nations/${encodeURIComponent(normalizedNationId)}/regions`,
        "recupero regioni"
    );
}
